import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { ProgressIndicatorStatusItem } from '../radial-stepper/radial-stepper'
import { ThemeSwitcherService } from '../../../../core/services/theme-switcher.service'

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit, OnDestroy {
    @Input() statusItem!: ProgressIndicatorStatusItem
    @Input() currentStatus = 0

    innerWidth: number = 0

    isDarkModeEnabled = false
    private themeServiceSubscription!: Subscription

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.innerWidth = window.innerWidth
    }

    constructor(public themeSwitcherService: ThemeSwitcherService) {}

    ngOnInit() {
        this.innerWidth = window.innerWidth
        this.themeServiceSubscription = this.themeSwitcherService.isDarkModeEnabled$.subscribe(
            value => {
                this.isDarkModeEnabled = value
            },
        )
    }

    ngOnDestroy(): void {
        this.themeServiceSubscription.unsubscribe()
    }

    progressIsComplete() {
        if (this.isRejected()) return false

        const completionStatus = this.statusItem.approvalStatuses.find(
            status => status.isCompletionStatus,
        )
        // @ts-ignore
        return this.currentStatus === completionStatus.id
    }

    getStatusList() {
        return this.isRejected()
            ? [this.statusItem.rejectStatuses.find(status => status.id === this.currentStatus)]
            : this.statusItem.approvalStatuses
    }

    canRenderStatusLine(index: number) {
        return index < this.statusItem.approvalStatuses.length - 1 && !(this.innerWidth <= 480)
    }

    statusIsComplete(statusId: any): boolean {
        if (this.isRejected()) return false

        const statusToBeChecked = this.statusItem.approvalStatuses.find(
            status => status.id === statusId,
        )

        // @ts-ignore
        return (
            statusId < this.currentStatus ||
            // @ts-ignore
            (statusToBeChecked.isCompletionStatus && this.progressIsComplete())
        )
    }

    statusIsActive(statusId: any) {
        return statusId === this.currentStatus
    }

    isRejected() {
        return this.statusItem.rejectStatuses.some(status => status.id === this.currentStatus)
    }
}
